<!-- eslint-disable max-len -->
<template>
  <div>
    <Card
      title="Credits Amount"
    >
      <template v-slot:button>
        <Button @clicked="isShowingModalAdd = true" label="Add Credits" variant="primary"/>
      </template>
      <template v-slot:body>
        <data-tables-server ref="tableTransaction" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [displayingItem] }" @query-change="onChangeTable" >
          <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
          </el-table-column>
          <el-table-column label="Actions" align="right" min-width="100px">
            <template slot-scope="scope">
              <div class="static inline-block text-left container-action">
                <VueCustomTooltip label="Edit" :position="'is-left'">
                  <button @click="update = scope.row; isShowingModalEdit = true" class="p-2 mr-2 rounded bg-yellow-500 hover:bg-yellow-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'pencil-alt']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip label="Delete" :position="'is-left'">
                  <button  @click="submitDeleteCredits(scope.row)"  class="p-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                  </button>
                </VueCustomTooltip>
              </div>
            </template>
          </el-table-column>
        </data-tables-server>
      </template>
    </Card>
    <ModalDialog
      :isShowingModal="isShowingModalAdd"
      :isLoading="isLoading"
      :error="isError"
      :errorMsg="errorMsg"
      title="Add Credits Amount"
      :labelSubmit="'Add'"
      @toggleModal="isShowingModalAdd=!isShowingModalAdd"
      @save="submitAddCredits()" >
      <template slot="body" >
        <form class="flex w-full overflow-y-auto overflow-x-hidden" id="form-activity" autocomplete="off" >
          <div class="w-full p-2" >
            <form-item label='Country'>
              <el-select v-model="input.country" filterable placeholder="Select Country" class="w-full">
                <el-option
                  v-for="item in listCountry"
                  :key="item.code"
                  :label="item.code+' - '+item.name"
                  :value="item.code">
                </el-option>
              </el-select>
              <div class="flex flex-col pt-2" v-if="$v.input.country.$dirty">
                <text-error v-if="!$v.input.country.required" text="Please fill Country." />
              </div>
            </form-item>
            <form-item label='Currency'>
              <el-select v-model="input.currency" filterable placeholder="Select Currency" class="w-full">
                <el-option
                  v-for="item in dataCurrencies"
                  :key="item.id"
                  :label="item.id+' - '+item.label"
                  :value="item.id">
                </el-option>
              </el-select>
              <div class="flex flex-col pt-2" v-if="$v.input.currency.$dirty">
                <text-error v-if="!$v.input.currency.required" text="Please fill Currency." />
              </div>
            </form-item>
            <form-item label='Credit Amount'>
              <Input
                v-model="input.price_credit"
                placeholder="Amount of Credits"
                :error="$v.input.price_credit.$dirty && (!$v.input.price_credit.required || !$v.input.price_credit.decimal || !$v.input.price_credit.minValue)"
                maxlength="100"
              />
              <div class="flex flex-col pt-2" v-if="$v.input.price_credit.$dirty">
                <text-error v-if="!$v.input.price_credit.required" text="Please fill Amount of Credit." />
                <text-error v-if="!$v.input.price_credit.decimal" text="Please input numeric value." />
                <text-error v-if="!$v.input.price_credit.minValue" text="Please input greater than 0." />
              </div>
            </form-item>
            <form-item label='Price'>
              <Input
                v-model="input.price_dollar"
                placeholder="Price"
                :error="$v.input.price_dollar.$dirty && (!$v.input.price_dollar.required || !$v.input.price_dollar.decimal || !$v.input.price_dollar.minValue)"
                maxlength="100"
              />
              <div class="flex flex-col pt-2" v-if="$v.input.price_credit.$dirty">
                <text-error v-if="!$v.input.price_dollar.required" text="Please fill Price of Credit." />
                <text-error v-if="!$v.input.price_dollar.decimal" text="Please input numeric value." />
                <text-error v-if="!$v.input.price_dollar.minValue" text="Please input greater than 0." />
              </div>
            </form-item>
          </div>
        </form>
      </template>
    </ModalDialog>
    <ModalDialog
      :isShowingModal="isShowingModalEdit"
      :isLoading="isLoading"
      title="Edit Credits Amount"
      :labelSubmit="'Save'"
      @toggleModal="isShowingModalEdit=!isShowingModalEdit"
      @save="submitEditCredits()" >
      <template slot="body" >
        <form class="flex w-full overflow-y-auto overflow-x-hidden" id="form-activity-edit" autocomplete="off" >
          <div class="w-full p-2" >
            <form-item label='Country'>
              <el-select v-model="update.country" filterable placeholder="Select Country" class="w-full">
                <el-option
                  v-for="item in listCountry"
                  :key="item.code"
                  :label="item.code+' - '+item.name"
                  :value="item.code">
                </el-option>
              </el-select>
              <div class="flex flex-col pt-2" v-if="$v.update.country.$dirty">
                <text-error v-if="!$v.update.country.required" text="Please fill Country." />
              </div>
            </form-item>
            <form-item label='Currency'>
              <el-select v-model="update.currency" filterable placeholder="Select Currency" class="w-full">
                <el-option
                  v-for="item in dataCurrencies"
                  :key="item.id"
                  :label="item.id+' - '+item.label"
                  :value="item.id">
                </el-option>
              </el-select>
              <div class="flex flex-col pt-2" v-if="$v.update.currency.$dirty">
                <text-error v-if="!$v.update.currency.required" text="Please fill Currency." />
              </div>
            </form-item>
            <form-item label='Credit Amount'>
              <Input
                v-model="update.price_credit"
                placeholder="Amount of Credits"
                :error="$v.update.price_credit.$dirty && (!$v.update.price_credit.required || !$v.update.price_credit.decimal || !$v.update.price_credit.minValue)"
                maxlength="100"
              />
              <div class="flex flex-col pt-2" v-if="$v.update.price_credit.$dirty">
                <text-error v-if="!$v.update.price_credit.required" text="Please fill Amount of Credit." />
                <text-error v-if="!$v.update.price_credit.decimal" text="Please input numeric value." />
                <text-error v-if="!$v.update.price_credit.minValue" text="Please input greater than 0." />
              </div>
            </form-item>
            <form-item label='Price'>
              <Input
                v-model="update.price_dollar"
                placeholder="Price"
                :error="$v.update.price_dollar.$dirty && (!$v.update.price_dollar.required || !$v.update.price_dollar.decimal || !$v.update.price_dollar.minValue)"
                maxlength="100"
              />
              <div class="flex flex-col pt-2" v-if="$v.update.price_credit.$dirty">
                <text-error v-if="!$v.update.price_dollar.required" text="Please fill Price of Credit." />
                <text-error v-if="!$v.update.price_dollar.decimal" text="Please input numeric value." />
                <text-error v-if="!$v.update.price_dollar.minValue" text="Please input greater than 0." />
              </div>
            </form-item>
          </div>
        </form>
      </template>
    </ModalDialog>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import ModalDialog from '@/components/Common/ModalDialog';
import { validationMixin } from 'vuelidate';
import { required, decimal } from 'vuelidate/lib/validators';
import helpersMixins from '../mixins/helpers.mixins';
import Card from '@/components/Layout/Card.vue';
import { Button, FormItem, Input, Select, TextArea, TextError } from '@/components/Layout/Form';

const displayingItems = 50;
const greaterThanZero = value => value > 0;
export default {
  name: 'CreditsAmount',
  mixins: [validationMixin, helpersMixins],
  data() {
    return {
      isLoading: false,
      isShowingModalAdd: false,
      isShowingModalEdit: false,
      isError: false,
      errorMsg: '',
      data: [],
      total: 0,
      displayingItem: displayingItems,
      dataCountries: [],
      dataCurrencies: [],
      titles: [{
        prop: 'country_name',
        label: 'Country',
      }, {
        prop: 'price_credit',
        label: 'Credit Amount',
      }, {
        prop: 'currency',
        label: 'Currency',
      }, {
        prop: 'price_dollar_text',
        label: 'Price',
      }],
      filter: {
        page: 1,
        per_page: displayingItems,
        sortby: 'country',
        sortorder: 'desc',
      },
      input: {
        country: '',
        currency: '',
        price_credit: 0,
        price_dollar: 0,
      },
      update: {
        id: null,
        country: '',
        currency: '',
        price_credit: 0,
        price_dollar: 0,
      },
    };
  },
  validations() {
    let rules = {
      input: {
        country: {},
        currency: {},
        price_dollar: {},
        price_credit: {},
      },
      update: {
        country: {},
        currency: {},
        price_dollar: {},
        price_credit: {},
      },
    };

    if (this.isShowingModalAdd) {
      rules = Object.assign(rules, {
        input: {
          country: {
            required,
          },
          currency: {
            required,
          },
          price_dollar: {
            required,
            decimal,
            minValue: greaterThanZero,
          },
          price_credit: {
            required,
            decimal,
            minValue: greaterThanZero,
          },
        },
      });
    }

    if (this.isShowingModalEdit) {
      rules = Object.assign(rules, {
        update: {
          country: {
            required,
          },
          currency: {
            required,
          },
          price_dollar: {
            required,
            decimal,
            minValue: greaterThanZero,
          },
          price_credit: {
            required,
            decimal,
            minValue: greaterThanZero,
          },
        },
      });
    }
    return rules;
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListCountry();
    this.dataCountries = this.getCountries();
    this.dataCurrencies = this.getCurrencies();
    await this.requestListCredits(this.filter);
  },
  computed: {
    ...mapGetters('CreditsAmountModule', ['listCredits']),
    ...mapGetters('NotificationModule', ['getMessage']),
    ...mapGetters('AppSettingModule', ['listCountry']),
  },
  watch: {
    listCredits: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (this.listCredits.data !== undefined) {
          this.data = this.listCredits.data.data.map(credit => ({ ...credit, price_dollar_text: `${credit.price_dollar ? this.formatPrice(credit.price_dollar) : 0}` }));
          this.total = this.listCredits.data.total;
        }
      },
    },
  },
  methods: {
    ...mapActions('CreditsAmountModule', ['requestListCredits', 'requestAddCredits', 'requestEditCredits', 'requestDeleteCredit']),
    ...mapActions('AppSettingModule', ['requestListCountry']),
    async search() {
      await this.requestListCredits(this.filter);
    },
    async reset() {
      this.$refs.tableTransaction.$refs.elTable.clearSort();
      this.filter = {
        page: 1,
        per_page: this.displayingItem,
        sortby: 'id',
        sortorder: 'desc',
      };
      this.search();
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filter = Object.assign(this.filter, { per_page: this.displayingItem, sortorder, sortby, page });
      await this.requestListCredits(this.filter);
    },
    async submitAddCredits() {
      this.isError = false;
      this.errorMsg = false;
      try {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          const data = {
            price_credit: this.input.price_credit,
            price_dollar: this.input.price_dollar,
            currency: this.input.currency,
            country: this.input.country,
          };
          await this.requestAddCredits({ data, filter: this.filter });
          this.isShowingModalAdd = false;
          this.$v.$reset();
          this.input = { price_dollar: 0, price_credit: 0, country: '', currency: '' };
        }
      } catch (err) {
        this.isError = true;
        this.errorMsg = this.getMessage;
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
    async submitEditCredits() {
      try {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          const data = {
            id: this.update.id,
            price_credit: this.update.price_credit,
            price_dollar: this.update.price_dollar,
            currency: this.update.currency,
            country: this.update.country,
          };
          await this.requestEditCredits({ data, filter: this.filter });
          this.isShowingModalEdit = false;
          this.$v.$reset();
          this.input = { id: null, price_dollar: 0, price_credit: 0 };
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
    async submitDeleteCredits(credit) {
      Vue.swal({
        title: 'Delete Data!',
        text: 'Are you sure to delete credit amount?',
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestDeleteCredit({ data: { id: credit.id }, filter: this.filter });
          this.$swal('Deleted', `You successfully credit amount: ${credit.price_credit}`, 'success');
        }
      });
    },
  },
  components: {
    VueCustomTooltip, ModalDialog,
    Card,
    Button,
    FormItem, Input, TextArea, TextError, Select
  },
};
</script>
<style scoped>
.z-1000{
  z-index: 1000;
}
.mx-400{
  max-height: 50%;
  height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/views/CreditsAmount.vue